import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, Grid, Paper, Typography, alpha } from '@mui/material';
import {
  Payments, AccountBalanceWallet,
  ArrowForward,
} from '@mui/icons-material';
import { selectEnabledModules } from '../../store/slices/tenantSlice';
import DashboardSection from '../dashboard/DashboardSection';

const VENDOR_ACTIONS = [
  { label: 'Settlements', path: '/settlements', icon: Payments, color: '#0284c7' },
  { label: 'Wallet', path: '/wallet', icon: AccountBalanceWallet, module: 'wallet', feature: 'wallet', color: '#6366f1' },
];

export default function VendorHubQuickActions() {
  const navigate = useNavigate();
  const enabledModules = useSelector(selectEnabledModules);
  const enabledFeatures = useSelector((s: { tenant: { enabledFeatures?: string[] } }) => s.tenant.enabledFeatures || []);

  const actions = useMemo(() => VENDOR_ACTIONS.filter((a) => {
    if (a.module && !enabledModules.includes(a.module)) return false;
    if (a.feature && !enabledFeatures.includes(a.feature)) return false;
    return true;
  }), [enabledModules, enabledFeatures]);

  if (!actions.length) return null;

  return (
    <DashboardSection title="Vendor Hub" subtitle="All store operations — food, grocery, menu, inventory, and payouts" accent="#059669">
      <Grid container spacing={1.5}>
        {actions.map((action) => {
          const Icon = action.icon;
          return (
            <Grid item xs={6} sm={4} md={3} key={action.path}>
              <Paper
                elevation={0}
                onClick={() => navigate(action.path)}
                sx={{
                  p: 2,
                  borderRadius: 2.5,
                  border: 1,
                  borderColor: 'divider',
                  cursor: 'pointer',
                  height: '100%',
                  transition: 'all 0.15s ease',
                  '&:hover': {
                    borderColor: action.color,
                    boxShadow: `0 8px 24px ${alpha(action.color, 0.15)}`,
                    transform: 'translateY(-2px)',
                  },
                }}
              >
                <Box display="flex" alignItems="flex-start" justifyContent="space-between" gap={1}>
                  <Box>
                    <Box sx={{ color: action.color, display: 'flex', mb: 0.75 }}><Icon fontSize="small" /></Box>
                    <Typography variant="body2" fontWeight={700} lineHeight={1.35}>{action.label}</Typography>
                  </Box>
                  <ArrowForward sx={{ fontSize: 16, color: 'text.disabled', mt: 0.25 }} />
                </Box>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </DashboardSection>
  );
}
